import React, { useEffect, useState } from "react"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./Home.scss"
import slider from "../assets/icons/slider.svg"
import BannerSlider from "../commonComponents/BannerSlider"
import CommonSlider from "../commonComponents/CommonSlider"
import config, { getHeaders } from "../config"
import { reactLocalStorage } from 'reactjs-localstorage'
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import _ from "lodash";
import { logEventHome } from "../Analytics/AnalyticsEvent"
import { screen } from "../Analytics/EventName"
import { SendGuiDataEvents } from "../CommonSript"

function Home({ games, banners, view_btn_txt, loading, setLoading, flow }) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [heMsg, setHeMsg] = useState('')
    let history = useHistory();
    let location = useLocation();
    let params = queryString.parse(location.search);
    const [msisdn, setMsisdn] = useState()
    const [campId, setCampId] = useState('');
    const [rcId, setRcId] = useState('');
    const subStatus = localStorage.getItem("subStatus")
    const msisdn2 = localStorage.getItem("msisdn")
    const msisdn3 = localStorage.getItem("tempMsisdn")
    const campid = localStorage.getItem("campId")
    const rcid = localStorage.getItem("rcId")
    
    const handleClick = () => {
        // Apply check when clicking anywhere on the page
        if (!(msisdn || msisdn2 || msisdn3)) {
            history.push('/login');
        }
        if (msisdn2 === "undefined") {
            history.push('/login');
        }
    };

    useEffect(() => {
        if (params.camp && params.rcid && !subStatus) {
            setCampId(params.camp);
            setRcId(params.rcid);
            localStorage.setItem("campId", params.camp);
            localStorage.setItem("rcId", params.rcid);
            localStorage.setItem("subStatus", "null");
            history.push("/subs")
        }
    }, [params, subStatus]);


    const settings = {
        dots: true,
        infinite: true,
        speed: 500
    };

    function capatalize(title) {
        return title?.charAt(0)?.toUpperCase() + title?.slice(1);
    }

    const callback = () => {
        console.log("callback called");
        const msisdn = localStorage.getItem("msisdn")
        const campId = localStorage.getItem("campId")
        const rcId = localStorage.getItem("rcId")
        let guiDataEvents = {
            page: "home",
            event: "callBackApi_request",
            campId:campId,
            rcId:rcId
        };
        SendGuiDataEvents(guiDataEvents);
        const url = "https://camp-report.bngrenew.com/cg_etl_dubai.php"
        const headers={
            ...getHeaders()
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({ 'msisdn': msisdn, 'camp': campId, 'rcid': rcId }),
            headers: headers
        })
            .then(res => {
                if(res.statusText === "OK"){
                    localStorage.removeItem("campId")
                    localStorage.removeItem("rcId")
                }
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
               if(result === "ok"){
                let guiDataResEvents = {
                    page: "home",
                    event: "callBackApi_response",
                    campId:campId,
                    rcId:rcId
                };
                SendGuiDataEvents(guiDataResEvents);
                localStorage.removeItem("campId")
                localStorage.removeItem("rcId")
               }
            },
                (error) => {
                    console.log('error:::', error)
                })
    }

    const checksub = (msisdn) => {
        let guiDataEvents = {};
      guiDataEvents["page"] = "home";
      guiDataEvents["event"] = "checksub_resquest";
      SendGuiDataEvents(guiDataEvents);
        const SubStatus = localStorage.getItem("subStatus")
        setLoading(true)
        const url = `${config.get('base')}${config.get('checkSub')}`
        const headers = {
            ...getHeaders(),
            // 'Language' : lang
        }
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'msisdn': msisdn,
                // "pin":urlPin,
            }),
            headers: headers
        })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                const checksubStatus = result?.subStatus ? result?.subStatus : "failed"
                setLoading(false)
                console.log('result message::', result)
                reactLocalStorage.set("subStatus", result.subStatus)
                const prevSubStatus = reactLocalStorage.get("subStatus");
                reactLocalStorage.set("status_display", result.status_display)
                reactLocalStorage.set("showUnsub", result.showUnsub)
                reactLocalStorage.set("msisdn", result.msisdn)
                reactLocalStorage.set("unsubtext", result.unsub_msg_txt)
                reactLocalStorage.set("validity", result.validity)
                reactLocalStorage.set("activePlan", result.subType)
                reactLocalStorage.set("unsubmsg", result.unsubmsg)
                setLoading(false)
                let guiDataResEvents = {};
                guiDataResEvents["page"] = "home";
                guiDataResEvents["event"] = "checksub_response";
                guiDataResEvents["status"] = checksubStatus;
                SendGuiDataEvents(guiDataResEvents);
                if (result?.status === "success") {
                    if(result?.subStatus === 'active' && campid && rcid){
                        callback();
                    }
                    if (result?.subStatus === 'active' || result?.subStatus === 'demo') {
                        localStorage.setItem("wasCheckSubDone", true)
                        history.push("/home")
                    }
                    else if(result?.subStatus === 'new'){
                        history.push("/subs");
                    }
                    else {
                        history.push("/subs");
                    }
                }
                else {
                    history.push({
                        pathname: "/info",
                        state: { status: "checksubfailed", customMessage: result?.message }
                    })

                }
                logEventHome(
                    {
                        screen: screen.homePage,
                        event: "checksub_api_success"
                    },
                    {
                        others: {
                            status: result.subStatus ? result.subStatus : "",
                            msisdn: msisdn ? msisdn : "NA"
                        }
                    });
            },
                (error) => {
                    console.log('error:::', error)
                })
    }
    useEffect(() => {
        const params = window.location.href;
        const paramsArray = params.split('&');
        let msisdnValue = '';
        let pinValue = '';
        const msisdnParam = paramsArray.find(param => param.includes('msisdn'));
        if (msisdnParam) {
            const keyValue = msisdnParam.split('=');
            msisdnValue = keyValue[1];
            setMsisdn(msisdnValue)
            localStorage.setItem("msisdn", msisdn)
        }
        const pinParam = paramsArray.find(param => param.includes('pin'));
        if (pinParam) {
            const keyValue = pinParam.split('=');
            pinValue = keyValue[1];
            // setUrlPin(pinValue)
        }
        if (msisdn) {
            checksub(msisdn)
        }
    }, [msisdn])

    function closeModal() {
        setIsOpen(false);
    }

    function handleClicked() {
        if (config.get('domain') === 'btc') {
            window.location.reload();
        } else {
            history.push('/login')
        }
    }

    useEffect(()=>{
        if(localStorage.getItem("msisdn")){
        sendHomeOpenEvent();
        }
    },[])

    const sendHomeOpenEvent=async ()=>
        {
            let guiEvents = {};
            guiEvents["page"] = "home";
            guiEvents["event"] = "open";
            await SendGuiDataEvents(guiEvents);
        }

    return (
        <>
            {
                loading ? <div className="loader-container">
                    <div className="lds" >
                    </div>
                </div> :

                    <div className="container m-w" onClick={handleClick}>
                        {banners && banners.length ? (
                            <BannerSlider
                                settings={{
                                    ...settings,
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    swipeToSlide: true,
                                    infinite: true,
                                    swipe: true,
                                    autoplay: true,
                                    speed: 200,
                                    autoplaySpeed: 1500,
                                    cssEase: "linear",
                                    customPaging: () => <div className="dot-outer"><div className="dot"></div></div>,
                                    onSwipe: () => slider.current.slickPause()
                                }}
                                data={banners} />) : ""}
                        {games &&
                            _.map(games).map((item, index) => (
                                <CommonSlider
                                    settings={{
                                        ...settings,
                                        dots: false,
                                        arrows: false,
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        centerPadding: "10%",
                                        swipeToSlide: true,
                                    }}
                                    title={capatalize(item.title)}
                                    data={item.contents}
                                    key={index}
                                    category={item.title}
                                    view_btn_txt={view_btn_txt}
                                />
                            ))}

                    </div>}
        </>
    )
}

export default Home